export const GET_USER_NOTEBOOKS = "GET_USER_NOTEBOOKS";
export const GET_USER_NOTEBOOK_BY_ID = "GET_USER_NOTEBOOK_BY_ID";
export const UPDATE_USER_NOTEBOOK = "UPDATE_USER_NOTEBOOK";
export const DELETE_USER_NOTEBOOK = "DELETE_USER_NOTEBOOK";
export const CREATE_USER_NOTEBOOK = "CREATE_USER_NOTEBOOK";
